import cn from 'classnames';
import { RefreshIcon } from '#assets/ReactSvg.ts';
import { InlineButton } from '#components/atoms/buttons/inline-button/InlineButton.tsx';
import styles from './ResetButton.module.css';

type Props = {
  onClick: () => void;
  isShown?: boolean;
  tagName?: string;
};

export function ResetButton({ onClick, isShown, tagName }: Props) {
  return (
    <InlineButton onClick={onClick} className={cn(styles.ResetButton, { [styles.ResetButton___visible]: isShown })}>
      <RefreshIcon aria-hidden height={12} width={12} />
      {`Reset to ${tagName ?? 'default'}`}
    </InlineButton>
  );
}
